import { TCapacityBannerConfig, TSeatLimitNoticeConfig } from "@/types";

/**
 * Default copy for the large-group messaging. The theme can override every
 * string (Main Track seats block / Date & time block); a blank or missing
 * setting falls back to these.
 */

/** Drivers step notice. `{max}` = Sprint track session limit, `{over}` = drivers over it. */
export const DEFAULT_SEAT_LIMIT_NOTICE: TSeatLimitNoticeConfig = {
  marker: "Weekend & holiday max {max}",
  title: "{over} over the weekend & holiday maximum",
  description: "Weekend and holiday sessions seat up to {max} drivers.",
};

/**
 * Date screen banner. `{day}` = selected weekday, `{seats}` = group size,
 * `{max}` = session limit, `{next_date}` = next date that fits, `{seats_left}` =
 * most seats left in one session on the selected date.
 */
export const DEFAULT_CAPACITY_BANNER: TCapacityBannerConfig = {
  title: "No time on {day} fits {seats} drivers",
  textNextDate: "Sprint track sessions seat up to {max}. {next_date} has room for your whole group.",
  textNoDate: "Sprint track sessions seat up to {max}. Try another date for your whole group.",
  jumpButton: "Jump to {next_date}",
  bookButton: "Book all {seats_left} here",
};

/** Fills each blank or missing string in `config` from `defaults`. */
export function withDefaultCopy<T extends Record<string, string>>(config: Partial<T> | null | undefined, defaults: T): T {
  const filled = { ...defaults };
  for (const key of Object.keys(defaults) as (keyof T)[]) {
    const value = config?.[key];
    if (typeof value === "string" && value.trim()) {
      filled[key] = value as T[keyof T];
    }
  }
  return filled;
}
